import { render, staticRenderFns } from "./DrinkMobile.vue?vue&type=template&id=402318ff&scoped=true&"
import script from "./DrinkMobile.vue?vue&type=script&lang=js&"
export * from "./DrinkMobile.vue?vue&type=script&lang=js&"
import style0 from "./DrinkMobile.vue?vue&type=style&index=0&id=402318ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402318ff",
  null
  
)

export default component.exports